<template>
  <div class="mainContent helpContent">
    <pageHead device="desktop" page="disclaimer02" :title="$t('store.disclaimer_title')"/>
    <div class="rule container">
      <h1 class="title lkrule"><span>{{ $t("store.disclaimer_title") }}</span></h1>
      <section
        class="rule-cont"
        v-for="(item, index) in Disclaimer02"
        :key="index"
      >
        <div v-html="item.description"></div>
      </section>
    </div>
  </div>
</template>

<script>
  import { getJsonFile } from '@/utils/jsonFile';
  import pageHead from "~/components/common/pageHead.vue";
  export default {
    components: { pageHead },
    computed: {
      Disclaimer02() {
        return getJsonFile(process.env.DEF_webStyle, 'disclaimer02');
      },
      HasX() {
        return Object.keys(this.$route.query).indexOf('x') >= 0;
      },
      Title() {
        return this.$t("store.disclaimer_title") + (this.HasX ? ' - ' + process.env.WEB_TITLE : '');
      }
    }
  };
</script>
